import React from "react";
import { SectionShell, Field, CheckboxGroup } from "./PartnerFormPrimitives";
import { TRADES } from "./partnerConstants";
import { toggleInArray } from "./partnerHelpers";

export default function PartnerTradesServices({ data, setRaw }) {
  const toggle = (val) => setRaw("trades_offered", toggleInArray(data.trades_offered, val));
  return (
    <SectionShell
      index={3}
      title="Trades & Services Offered"
      subtitle="Pick every trade you self-perform. Your selection drives the pricing fields in the next section."
      testId="partner-section-trades"
    >
      <Field label="Trades and Services Offered" required>
        <CheckboxGroup
          options={TRADES}
          value={data.trades_offered}
          onChange={toggle}
          columns={3}
          testIdPrefix="partner-trade"
        />
      </Field>

      {data.trades_offered.includes("Other") && (
        <Field label="Other Trades or Services">
          <input className="input-br" value={data.trades_other} onChange={(e) => setRaw("trades_other", e.target.value)} placeholder="Describe other trades..." />
        </Field>
      )}
    </SectionShell>
  );
}
